/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import {
  ArgsGetAgencies,
  ArgsGetAgencyPricing,
  ArgsGetAgencyProducts,
  ArgsGetAgencyUsers,
  IAgency,
} from '~/types/agencies';

const getAgencies = async (params: ArgsGetAgencies) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/agencies`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data;
};

const getAgency = async (id: string) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/agencies/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.agency;
};

const getAgencyPricing = async (params: ArgsGetAgencyPricing) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { id, ...requestParams } = params;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/agencies/${id}/pricing`,
    {
      headers: {
        Authorization: token,
      },
      params: requestParams,
    },
  );
  return data.pricing;
};

// eslint-disable-next-line max-len
const updateAgencyPricing = async (data: { _id: string, location: string, key: string, value: number }): Promise<{ agency: IAgency }> => {
  const token = localStorage.getItem('token');
  const {
    _id,
    key,
    value,
    location,
  } = data;

  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}/agencies/${_id}/pricing`,
    {
      key,
      value,
      location,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return response.data;
};

const getAgencyUsers = async (params: ArgsGetAgencyUsers) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { id, ...requestParams } = params;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/agencies/${id}/users`,
    {
      headers: {
        Authorization: token,
      },
      params: requestParams,
    },
  );
  return data.users;
};

const getAgencyProducts = async (params: ArgsGetAgencyProducts) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { id } = params;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/agencies/${id}/products`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.products;
};

const addAgencyProduct = async (
  data: { _id: string, productId: string },
): Promise<{ agency: IAgency }> => {
  const token = localStorage.getItem('token');
  const { _id, productId } = data;

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/agencies/${_id}/products`,
    { productId },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

const updateAgencyProducts = async (data: {
  _id: string,
  productId: string,
  key: 'pricePerM2' | 'flatPrice' | 'pricePerLinearMeter' | 'pricePerTon' | 'pricePerUnit' | 'prestationPricePerM2' | 'prestationFlatPrice' | 'prestationPricePerUnit',
  value: number,
})
: Promise<{ agency: IAgency }> => {
  const token = localStorage.getItem('token');
  const {
    _id,
    productId,
    key,
    value,
  } = data;

  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}/agencies/${_id}/products`,
    {
      productId,
      key,
      value,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return response.data;
};

const removeAgencyProduct = async (
  data: { _id: string, productId: string },
): Promise<{ agency: IAgency }> => {
  const token = localStorage.getItem('token');
  const { _id, productId } = data;

  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/agencies/${_id}/products/${productId}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export {
  getAgency,
  getAgencies,
  getAgencyPricing,
  updateAgencyPricing,
  getAgencyUsers,
  getAgencyProducts,
  addAgencyProduct,
  updateAgencyProducts,
  removeAgencyProduct,
};
